export default "__VITE_ASSET__BpCaybIf__"